import React from 'react';
import t from 'babel-plugin-yate/macro';
import {withRouter} from 'react-router-dom';

import DisplayBoxSmaller from '../components/DisplayBoxSmaller';
import Icon from './Icons';

// { [currentNr]: { [lendingType]: description } }
const descriptions = {
  1: {
    1001: t`Confirma date tranzactie`,
  },
  2: {
    1001: t`Genereaza document`,
  },
  3: {
    1001: t`Autorizeaza tranzactie`,
  },
  4: {
    1001: t`Factura`,
  },
};

function RequestNav(props) {
  const {currentStep, lendingTypeId} = props;

  const steps = [
    {
      currentNr: 1,
      description: descriptions[1][lendingTypeId] ?? t`Personal data`,
      icon: 'ProfileRound',
    },
    {
      currentNr: 2,
      description: descriptions[2][lendingTypeId] ?? t`Data verification`,
      icon: 'CloudUp',
    },
    {
      currentNr: 3,
      description: descriptions[3][lendingTypeId] ?? t`Additional information`,
      icon: 'FileboardChecklist',
    },
  ];

  if (lendingTypeId === 4) {
    steps.push({
      currentNr: 4,
      description: descriptions[4][lendingTypeId] ?? t`Choose offer`,
      icon: 'GalleryGridView',
    });
  }

  return (
    <div className="flex flex-wrap my-6 overflow-x-auto">
      {steps.map(({currentNr, description, icon}, i) => (
        <div
          key={`${description}--${i}`}
          className="flex-auto w-1/4"
          style={{minWidth: '12rem'}}>
          <DisplayBoxSmaller
            currentNr={currentNr}
            color={
              currentStep === currentNr
                ? 'purple'
                : currentStep >= currentNr
                  ? 'green'
                  : undefined
            }
            description={description}
            fullWidth={false}
            icon={<Icon name={icon} width="20" height="20" />}
            isCurrentBox={currentStep === currentNr}
            key={currentNr}
            onClick={null}
          />
        </div>
      ))}
    </div>
  );
}

export default withRouter(RequestNav);
